<template>
<div>

<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
<div v-if="url!='ecrcom'">
    <iframe   v-show="false" :src="url + '/html/rest_proxy.htm'" id="crossJs" name="crossJs"></iframe>
</div>
</div>

</template>

<script>

import { mapGetters } from 'vuex';


import alertBox          from '@/components/common/AlertBox.vue'

//import api            from '@/api'

  export default {
  props : ['url','data','giftTicket','driver'],

     components: {alertBox},
    data () {
      return {
        
          auth     : "YWRtaW46YWRtaW4=",
          restCmd  : '',
          index    : -1,
          msg      : {title : '',body:'',type :0},
          cmd      : ''
          
        
        
      }
    },


    computed: {
     ...mapGetters(['company']),

     commands : function()
     {   
         let data           = []
         let total_discount = 0
         let payments       = []
        
        // CREDIT NOTE REST API
        if(this.data.creditNote)
        {

             data.push('cmd=INP+TERM=180&async=false')
             data.push('cmd=INP+TERM=145&async=false')
             data.push("cmd=INP+ALFA%3D%27" + this.data.creditNote.rt_badge + "%27%2CTERM%3D145&async=false")   
             data.push('cmd=INP+ALFA%3D' + this.data.creditNote.znumber + this.data.creditNote.numsco + '%2CTERM%3D145&async=false')   
             data.push('cmd=INP+NUM%3D'  + this.data.creditNote.datasco + '%2CTERM%3D145&async=false')  
             data.push('cmd=CLEAR&async=false')  

             this.data.data[0].forEach(item => {
             
                //total_discount = item.total_discount

                
                data.push('cmd=VEND+REP%3D1%2C+PRE%3D' + item.price + '%2CDES%3D%27'+ item.barcode + ' ' + item.category + '%27&async=false' )
               
                if(Number(item.discount)>0)
                {
                
                   data.push('cmd=SCONTO%20VAL%3D' + item.discount_value + '%2CDES%3D%27SCONTO%20' + item.discount + '%25%27&async=false' )
               
                }

            }); 
            data.push('cmd=CHIUS&async=false')  
            
            

            return data
              
             
             
        }

         if(this.data.data)
         {
            
            if(this.giftTicket)
            {   
                
              
                data.push('cmd=nofis+apri&async=false')
                data.push('cmd=nofis%20riga%3D%27SCONTRINO%20DI%20CORTESIA%27&async=false')                                
                data.push("cmd=nofis+riga%3D%27" + 'S' + this.data.saleId + "%27%2Cbarcode%3D2&async=false")                                 
                data.push('cmd=nofis+chiudi&async=false')    

                
            }
            else
            {
            if(this.data.lottery)
            {   
                    
                
                data.push('cmd=INP+TERM=167&async=false')
                data.push('cmd=INP+ALFA%3D'+ this.data.lottery + '%2CTERM%3D145&async=false')   

                
            } 
            this.data.data[0].forEach(item => {
             
                total_discount = item.total_discount

                //data.push('cmd=VEND+REP%3D1%2C+PRE%3D' + item.total_row + '%2CDES%3D%27'+ item.barcode + ' ' + item.category + '%27&async=false' )
                data.push('cmd=VEND+REP%3D1%2C+PRE%3D' + item.price + '%2CDES%3D%27'+ item.barcode + ' ' + item.category + '%27&async=false' )
               
                if(Number(item.discount)>0)
                {
                    //data.push('cmd=PERCA%20ALIQ%3D' + item.discount + '&async=false' )
                    data.push('cmd=SCONTO%20VAL%3D' + item.discount_value + '%2CDES%3D%27SCONTO%20' + item.discount + '%25%27&async=false' )
               
                }
            });

            if(Number(total_discount)>0)
            {   
                data.push('cmd=Sconto%20val%3D' + total_discount + '%2Csubtot&async=false')
               
            }


            data.push('cmd=alleg%20on&async=false')
                                    
            payments = this.data.data[1]
            payments.forEach(item=>{
                if(item.typeId == 'CASH')
                {
                    data.push('cmd=CHIUS%20t%3D1%2Cimp%3D' + item.total + '&async=false')    
            
                }
                if(item.typeId == 'ELEC')
                {
                    data.push('cmd=CHIUS%20t%3D5%2Cimp%3D' + item.total + '&async=false')    
            
                }
                if(item.typeId == 'CRED')
                {
                    data.push('cmd=CHIUS%20t%3D2%2Cimp%3D' + item.total + '&async=false')    
            
                }

            })
            
            
            data.push('cmd=alleg%20riga%3D%27' + 'S' +  this.data.saleId  + '%27%2Cbarcode%3D2&async=false')    
            

            data.push('cmd=alleg%20fine&async=false')    
            

            }
         }


        
        return data
     }

      
      
    },
    
    created () 
      {

        

        window.addEventListener('message',this.print);
        this.$on("hook:beforeDestroy", () => {
        window.removeEventListener('message', this.print);
        
    })

      },
        beforeDestroy() {
            //window.removeEventListener("message",this.print );
        },
    methods: 
    {
     
     print(e)
     {
        this.index++
        this.clickHandler() 
       
        console.log('Result',e.data)    

     },
     cmdData (nobarcode)
     {   
         


         let total_discount = 0
         let payments       = []
         let cmd            = 'data:text/csv;charset=utf-8,'
         let cr             = "\r\n"
        
        
        /* CREDIT NOTE */    
        if(this.data.creditNote)
        {
            
            
            cmd += 'INP TERM=180' + cr
            cmd += 'INP TERM=145' + cr
            cmd += "INP ALFA='" + this.data.creditNote.rt_badge + "',TERM=145" + cr
            cmd += "INP ALFA=" + this.data.creditNote.znumber + this.data.creditNote.numsco + ",TERM=145" + cr
            cmd += "INP NUM=" + this.data.creditNote.datasco + ",TERM=145" + cr
            cmd += 'CLEAR' + cr

            /*    
            cmd += 'NOTACRED NUMSCO=' + this.data.creditNote.numsco +  ',' 
             cmd += 'ZNUMBER=' + this.data.creditNote.znumber + ',DATASCO=' + this.data.creditNote.datasco  +  ',' 
             cmd += "MATR='" + this.data.creditNote.rt_badge + "'" + cr
            */

             this.data.data[0].forEach(item => {
                             
                if(nobarcode)
                {
                    cmd += "VEND REP=1,PRE=" + item.price + ",DES='" + item.category + "'" + cr
                }
                else
                {
                    cmd += "VEND REP=1,PRE=" + item.price + ",DES='" +  item.barcode + " " + item.category + "'" + cr
                }    
                
                if(Number(item.discount)>0)
                {
                
             
                    cmd += "SCONTO VAL=" + item.discount_value + ",DES='SCONTO " +  item.discount + "%'" + cr
                }
                
            })
            cmd += 'CHIUS' + cr
            this.cmd = cmd
            return this.cmd

        }    
        if(this.data.data)
         {
            
            if(this.giftTicket)
            {   
                

                cmd += 'nofis apri' + cr
                cmd += "nofis riga='SCONTRINO DI CORTESIA'" + cr
                cmd += "nofis riga ='" + "S" + this.data.saleId + "',barcode=2" + cr
                cmd += 'nofis chiudi' + cr

             
                
            }
            else
            {
            if(this.data.lottery)
            {   
                cmd += 'INP TERM=167' + cr
                cmd += "INP ALFA='" + this.data.lottery + "',TERM=145" + cr                            
                    
                
                
            } 
            
            this.data.data[0].forEach(item => {
             
                total_discount = item.total_discount

                
                if(nobarcode)
                {
                    cmd += "VEND REP=1,PRE=" + item.price + ",DES='" + item.category + "'" + cr
                }
                else
                {
                    cmd += "VEND REP=1,PRE=" + item.price + ",DES='" +  item.barcode + " " + item.category + "'" + cr
                }    
                if(Number(item.discount)>0)
                {
                
             
                    cmd += "SCONTO VAL=" + item.discount_value + ",DES='SCONTO " +  item.discount + "%'" + cr
                }
            });
            payments = this.data.data[1]
            
            const coupon = payments.filter(item=>item.typeId == 'COUP')
            
            if (coupon.length>0)
            {
                total_discount += coupon[0].total
            }
            const cb = payments.filter(item=>item.typeId == 'CB')
            
            if (cb.length > 0)
            {
                total_discount += cb[0].total
            }

            if(Number(total_discount)>0)
            {   
             
                cmd += 'SCONTO VAL=' + total_discount + ',SUBTOT' + cr
            }


            
            cmd += 'ALLEG ON' + cr
           
                        
            const total_elec =   payments.filter(item => item.typeId == 'ELEC' || item.typeId == 'PAGO' || item.typeId == 'SCAL') 
            payments.forEach(item=>{
                if(item.typeId == 'CASH')
                {
            
                    cmd += 'CHIUS T=1,imp=' + item.total + cr

                }
                /*
                if(item.typeId == 'ELEC' || item.typeId == 'PAGO')
                {
                    
                    cmd += 'CHIUS T=5,imp=' + item.total + cr
                }
                */

                if(item.typeId == 'CRED')
                {
            
                    cmd += 'CHIUS T=2,imp=' + item.total + cr
                }

            })

            // ELEC PAYMENT
            let total = 0
            total_elec.forEach(item=>{
                total += item.total
            })
            if(total > 0)
            {
                cmd += 'CHIUS T=5,imp=' + total + cr
            }
            
            console.log('DITRON TOTAL ELEC',total)

            cmd += "alleg riga='" + "S" +  this.data.saleId  + "',barcode=2" + cr

            
            cmd += 'alleg fine' + cr

            }
         }


        this.cmd = cmd
        return this.cmd
     },

    
     clickHandler() {
            
            if(this.driver=="ecrcom")
            {
                let cmd = this.cmdData('')
                var encodedUri = encodeURI(cmd)
                var link = document.createElement("a")
                link.setAttribute("href", encodedUri)
                link.setAttribute("download", "sco.txt")
                link.click()    
                
                this.$emit('finish')
            return 
            }

            if(this.driver=="ecrcom_custom")
            {
                let cmd = this.cmdData('nobarcode')
                var encodedUri = encodeURI(cmd)
                var link = document.createElement("a")
                link.setAttribute("href", encodedUri)
                link.setAttribute("download", "sco.txt")
                link.click()    
                
                this.$emit('finish')
            return 
            }

            if (this.index == -1)

                this.restCmd = { "method": "POST", "uri": "/ecrwec/init", "body": "", "auth": this.auth };
                
            else if ((this.index >= 0) && (this.index < this.commands.length))

                this.restCmd = { "method": "POST", "uri": "/ecrwec/cmd", "body": this.commands[this.index], "auth": this.auth };

            else

                this.restCmd = { "method": "POST", "uri": "/ecrwec/close", "body": "", "auth": this.auth };
    
            if (this.index <= this.commands.length)
            {
                            
                $("iframe[name='crossJs']")[0].contentWindow.postMessage(this.restCmd, this.url);

               
                            
            }
            
            else
            {

                this.index = -1;                                        
                this.$emit('finish')

            }    
      
      
        }
  
      
    }
  }
</script>
<style scoped>

 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}

</style>
